var $ = require('jquery');

/**
 * Synchronizes forms input data.
 */
function synchronizeData() {
    $('#formUserPersonRegister input').each(function(index, item) {
        var val = $(item).val();
        var str = $(item).attr('name');
        var substr = str.split('[')[1];
        var substr = substr.split(']')[0];

        if($(item).attr('id') != 'userPersonRegister__csrf_token') {
            $('input[name="userPersonRegister[' + substr + ']"]').val(val);
            $('input[name="userCompanyRegister[' + substr + ']"]').val(val);
        }
    });
}

var RecaptchaCallback = function() {
    $("#mns .formUserRegister div[id$='Register_recaptcha']").each(function(index) {
        var self = $(this);
        var id = self.attr('id');
        grecaptcha.render(id, {
            'sitekey':  self.data('sitekey'),
            'theme':    self.data('theme'),
            'type':     self.data('type'),
            'size':     self.data('size'),
            'callback': RecaptchaSuccessCallback
        });
    });
}

window.RecaptchaCallback = RecaptchaCallback;

var RecaptchaSuccessCallback = function(response) {
    var $user_type = $('#user_type');
    var $formUserRegister = $('#mns #formUserRegister');
    var $formUserPersonRegister = $('#mns #formUserPersonRegister');

    var recaptchaFormField = null;
    var name = null;
    switch($user_type.val()) {
        case 'company':
            name = 'formUserRegister';
            recaptchaFormField = $formUserRegister.find('.recaptcha-response');
            break;
        case 'person':
        default:
            name = 'formUserPersonRegister';
            recaptchaFormField = $formUserPersonRegister.find('.recaptcha-response');
            break;
    }

    if (recaptchaFormField.length == 0) {
        var container = document.getElementById(name);
        recaptchaFormField = $('<input type="hidden" name="' + name + '[recaptcha]" class="recaptcha-response" />');
        container.appendChild(recaptchaFormField[0]);
    }

    recaptchaFormField.val(response);
}

$(document).ready(function() {
    var $formUserRegister = $('#mns #formUserRegister');
    var $formUserPersonRegister = $('#mns #formUserPersonRegister');
    var $user_type = $('#user_type');

    switch($user_type.val()) {
        case 'company':
            $formUserRegister.show();
            $formUserPersonRegister.hide();
            break;
        case 'person':
        default:
            $formUserRegister.hide();
            $formUserPersonRegister.show();
            break;
    }

    $("body").on('click', "#mns #aCompany", function(e) {
        e.preventDefault();

        $("#register-company").addClass('active');
        $("#register-person").removeClass('active');

        synchronizeData();

        $("#aCompany").parents("li").removeClass('active');
        $("#aPerson").parents("li").addClass('active');
        $formUserRegister.show();
        $formUserPersonRegister.hide();
        return false;
    });

    $("body").on('click', '#mns #aPerson', function(e) {
        e.preventDefault();

        $("#register-company").removeClass('active');
        $("#register-person").addClass('active');

        synchronizeData();

        $("#aPerson").parents("li").removeClass('active');
        $("#aCompany").parents("li").addClass('active');
        $formUserRegister.hide();
        $formUserPersonRegister.show();
        return false;
    });
});

